import { Link, useSearchParams } from 'react-router';

export function SignedOutPage() {
  const [params] = useSearchParams();
  const app = params.get('app');
  return (
    <div className="card centered">
      <h1>You're signed out{app ? ` of ${app}` : ''}</h1>
      <p>You can close this tab. Open the app's link again whenever you need it.</p>
      <p className="small">
        <Link to="/">Go to the console</Link>
      </p>
    </div>
  );
}
